<div class="modal-content p-3">
    <div class="modal-body">

        <div class="row">
            <div class="col-sm-12">
                <button class="close mr-4 mt-4" type="button" (click)="close()"><i class="fa fa-times"></i></button>
            </div>
            <div class="col-12">
                <app-alert-message *ngFor="let message of messages; let i = index"
                    [message]="message.text"
                    [isError]="message.isError"
                    [isSuccess]="message.isSuccess"
                    (close)="removeMessage(i)"
                ></app-alert-message>
            </div>

            <div class="col-sm-12 mb-5">
                <h2 class=" mt-3">Seleccionar Rut</h2>
            </div>

            <ng-container *ngIf="showSpinner; else elseSpinner">
                <div class="col-sm-12 p-5 mt-5">
                    <div class="row">
                        <div class="col-sm-12 d-flex justify-content-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="col-sm-12 text-center mt-1">
                            <span>Cargando...</span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #elseSpinner>
                <div class="col-sm-12">
                    <form class="row" [formGroup]="formulario" (ngSubmit)="enviarRut()">
                        <div class="col-9 d-flex align-items-center">
                            <mat-form-field class="w-100" appearance="outline">
                                <input matInput placeholder="Rut" class="width-80" id="rut" formControlName="rut">
                                <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="formulario.get('rut')?.value" (click)="formulario.get('rut')?.setValue('')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-3 d-flex align-items-center pb-5">
                            <button
                                class="search-button mx-auto"
                                mat-fab color="primary" 
                                aria-label="Icono de busqueda"
                                type="submit"
                                [disabled]="!showTable"
                            >
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 max-height" *ngIf="showTable">
                    <div class="table-responsive">
                        <table class="border" mat-table [dataSource]="dataSource" matSort>
                            <ng-container matColumnDef="rut">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> <strong>Rut</strong> </th>
                                <td mat-cell *matCellDef="let element" class="text-center cursor-pointer" (click)="seleccionarRut(element.rut)"> {{element.rut | rutFormat}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['rut']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['rut'];"></tr>
                        </table>
                    </div>
                </div>
                <div class="col-12 mt-5" *ngIf="showTable">
                    <div class="row">
                        <div class="col-sm-12 col-md-4 mb-3 d-flex align-items-center">
                            Cantidad de Ruts: {{inputModel?.data?.totalElementos || 0}}
                        </div>
                        <div class="col-sm-12 col-md-8 mb-3 pb-3">
                            <div class="table-responsive">
                                <mat-paginator 
                                    [pageSizeOptions]="[10, 20, 50, 100]"
                                    [length]="totalItems"
                                    [pageSize]="pageSize"
                                    [pageIndex]="pageIndex"
                                    showFirstLastButtons 
                                    aria-label="Seleccionar página"
                                    (page)="handlePageEvent($event)"
                                >
                                </mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
                
        </div>

    </div>
</div>
